import { ethers } from "ethers"

const alchemyApiKey = process.env.ALCHEMY_API_KEY || process.env.NEXT_PUBLIC_ALCHEMY_API_KEY
const openseaApiKey = process.env.OPENSEA_API_KEY || process.env.NEXT_PUBLIC_OPENSEA_API_KEY

export const ethereumConfig = {
  mainnet: {
    rpcUrl: process.env.ETHEREUM_RPC_URL || process.env.NEXT_PUBLIC_ETHEREUM_RPC_URL,
    contractAddress: process.env.NEXT_PUBLIC_CONTRACT_ADDRESS_MAINNET,
    chainId: 1,
  },
  sepolia: {
    rpcUrl: process.env.SEPOLIA_RPC_URL || process.env.NEXT_PUBLIC_SEPOLIA_RPC_URL,
    contractAddress: process.env.NEXT_PUBLIC_CONTRACT_ADDRESS_SEPOLIA_NEW,
    chainId: 11155111,
  },
  apiKeys: {
    alchemy: process.env.ALCHEMY_API_KEY || process.env.NEXT_PUBLIC_ALCHEMY_API_KEY,
    alchemyBase: process.env.ALCHEMY_BASE_API_KEY || process.env.NEXT_PUBLIC_ALCHEMY_BASE_API_KEY,
    opensea: process.env.OPENSEA_API_KEY || process.env.NEXT_PUBLIC_OPENSEA_API_KEY,
    etherscan: process.env.ETHERSCAN_API_KEY || process.env.NEXT_PUBLIC_ETHERSCAN_API_KEY,
  },
}

// Debug: log both variables and resulting isTestnet
console.log('[ENV] NEXT_PUBLIC_USE_TESTNET:', process.env.NEXT_PUBLIC_USE_TESTNET, '| USE_TESTNET:', process.env.USE_TESTNET)

// Ethereum Configuration
export const ETHEREUM_CONFIG = {
  // Mainnet
  mainnet: {
    // Prefer env, otherwise use a public RPC (avoid Alchemy demo which may return invalid fee data / fail)
    rpcUrl: process.env.ETHEREUM_RPC_URL || process.env.NEXT_PUBLIC_ETHEREUM_RPC_URL || "https://cloudflare-eth.com",
    chainId: 1,
    name: "Ethereum Mainnet",
    url: `https://eth-mainnet.g.alchemy.com/v2/${alchemyApiKey}`,
    contractAddress: process.env.NEXT_PUBLIC_CONTRACT_ADDRESS || process.env.NEXT_PUBLIC_CONTRACT_ADDRESS_MAINNET || "0x2f7ba9643e8083152df22e0a477c7112d532837d",
  },
  
  // Sepolia Testnet
  sepolia: {
    rpcUrl: process.env.SEPOLIA_RPC_URL || process.env.NEXT_PUBLIC_SEPOLIA_RPC_URL || "https://rpc.sepolia.org",
    chainId: 11155111,
    name: "Sepolia Testnet",
    url: `https://sepolia.g.alchemy.com/v2/${alchemyApiKey}`,
    contractAddress: process.env.NEXT_PUBLIC_CONTRACT_ADDRESS_SEPOLIA_NEW || "0x38D19222F4Dd309Cbd1551bb7e141222D42A015b",
    coldlinkCollectionAddress: process.env.COLDLINK_COLLECTION_ADDRESS || process.env.NEXT_PUBLIC_CONTRACT_ADDRESS || "", // New NFTotem contract on Sepolia
  },
  base_sepolia: {
    rpcUrl: "https://sepolia.base.org",
    chainId: 84532,
    name: "Base Sepolia",
    contractAddress: process.env.COLDLINK_COLLECTION_ADDRESS || process.env.NEXT_PUBLIC_CONTRACT_ADDRESS || "",
  }
}

// API Keys
export const API_KEYS = {
      alchemy: process.env.ALCHEMY_API_KEY || process.env.NEXT_PUBLIC_ALCHEMY_API_KEY || "demo",
alchemyBase: process.env.ALCHEMY_BASE_API_KEY || process.env.NEXT_PUBLIC_ALCHEMY_BASE_API_KEY || "demo",
opensea: process.env.OPENSEA_API_KEY || process.env.NEXT_PUBLIC_OPENSEA_API_KEY || "demo",
etherscan: process.env.ETHERSCAN_API_KEY || process.env.NEXT_PUBLIC_ETHERSCAN_API_KEY || "demo",
  coldlink: process.env.COLDLINK_API_KEY || ""
}

// Coldlink Configuration
export const COLDLINK_CONFIG = {
  apiUrl: "https://coldlinkapi.xyz/v1",
  mintEndpoint: "/coldlinks",
  validateEndpoint: "/coldlinks",
  rateLimit: 10000, // requests per day
  maxItemsPerPage: 100
}

// Debug logging for configuration
console.log("Coldlink Configuration:", {
  apiUrl: COLDLINK_CONFIG.apiUrl,
  mintEndpoint: COLDLINK_CONFIG.mintEndpoint,
  validateEndpoint: COLDLINK_CONFIG.validateEndpoint,
  apiKey: process.env.COLDLINK_API_KEY ? "Set" : "Not set"
})

// Contract Configuration
export const CONTRACT_CONFIG = {
  sepolia: {
    contractAddress: process.env.NEXT_PUBLIC_CONTRACT_ADDRESS_SEPOLIA_NEW || "0x38D19222F4Dd309Cbd1551bb7e141222D42A015b",
    coldlinkCollectionAddress: process.env.COLDLINK_COLLECTION_ADDRESS || process.env.NEXT_PUBLIC_CONTRACT_ADDRESS || "", // New NFTotem contract on Sepolia
    mintingPrice: "0.003",
    chainId: 11155111,
    name: "Sepolia Testnet"
  },
  mainnet: {
    contractAddress: process.env.NEXT_PUBLIC_CONTRACT_ADDRESS || process.env.NEXT_PUBLIC_CONTRACT_ADDRESS_MAINNET || "0x2f7ba9643e8083152df22e0a477c7112d532837d",
    coldlinkCollectionAddress: process.env.COLDLINK_COLLECTION_ADDRESS || process.env.NEXT_PUBLIC_CONTRACT_ADDRESS || "",
    mintingPrice: "0.003",
    chainId: 1,
    name: "Ethereum Mainnet"
  }
}

// Debug contract addresses (removed - no longer needed)

// KV Storage Configuration
export const KV_CONFIG = {
  url: process.env.KV_REST_API_URL || "",
  token: process.env.KV_REST_API_TOKEN || "",
  readOnlyToken: process.env.KV_REST_API_READ_ONLY_TOKEN || "",
  redisUrl: process.env.REDIS_URL || ""
}

// Provider instances
export function getProvider(chain: "mainnet" | "sepolia" = "mainnet") {
  const config = ETHEREUM_CONFIG[chain]
  if (chain === "sepolia") {
    console.log("[DEBUG] Vercel SEPOLIA_RPC_URL:", process.env.SEPOLIA_RPC_URL)
    console.log("[DEBUG] Sepolia provider URL:", config.rpcUrl)
  }
  return new ethers.JsonRpcProvider(config.rpcUrl)
}

// Sepolia provider for testing
export const sepoliaProvider = getProvider("sepolia")

// Mainnet provider for production
export const mainnetProvider = getProvider("mainnet")

// Environment helpers
export const isDevelopment = process.env.NODE_ENV === "development"
export const isProduction = process.env.NODE_ENV === "production"
export const isTestnet = process.env.NEXT_PUBLIC_USE_TESTNET === "true" || process.env.USE_TESTNET === "true"
console.log('[ENV] isTestnet:', isTestnet, '| NODE_ENV:', process.env.NODE_ENV)

// Get current network based on environment
export function getCurrentNetwork() {
  // Prefer explicit flags. Development mode no longer forces Sepolia.
  if (isTestnet) return ETHEREUM_CONFIG.sepolia
  return ETHEREUM_CONFIG.mainnet
}

// Get current provider based on environment
export function getCurrentProvider() {
  if (isTestnet) return sepoliaProvider
  return mainnetProvider
}